







































































































import { getCouponCount } from '@/apps/index/models/api'
import { Component, Vue, Prop, Provide, Emit } from 'vue-property-decorator'
import { AButton } from '@/components'
import { loadFromLocal } from '@/utils/local'
import DownloadTip from '@/components/vip/DownloadTip.vue'
import { sa } from '@/utils/sa'

@Component({
  components: { AButton, DownloadTip }
})
export default class PaperItem extends Vue {
  public dataConfig: any = {}
  public avatar = {
    shape: 'square',
    size: 'large'
  }
  public tipShow = false
  public couponCount = 0
  @Prop() public loading!: boolean
  @Prop() public data!: any
  @Prop() public site!: any
  @Prop() public name!: any
  @Prop() public type!: string
  @Prop() public showExtra!: boolean
  /**
   * name
   */
  public realDownload(val: any) {
    this.tipShow = false
    if (this.couponCount > 0) {
      this.dataConfig['is_downloaded'] = true
    }
    let temp = Object.assign({}, val, this.dataConfig)
    this.clickDownload(temp)
  }
  public cancelDownloadShow(val: any) {
    this.tipShow = false
  }
  public async clickDownloadTip(data: any) {
    if (!loadFromLocal('net_username')) {
      this.$store.commit('SET_LOGINMODAL', true)
      return
    } else {
      let d = await getCouponCount({})
      if (d.success) {
        this.couponCount = d.coupon_num
        this.dataConfig = data
        if (this.showTip) {
          this.tipShow = true
        } else {
          this.clickDownload(data)
        }
      }
    }
  }
  @Emit()
  public clickDownload(data: any) {
    // console.log(data)
    // this.$message.warning('您还没有登录，请先登录')
    // if (!loadFromLocal('net_username')) {
    //   // this.$message.warning('您还没有登录，请先登录')
    //   return
    // }
    return data
  }
  public get subjectId() {
    return this.$store.state.subject.value || this.$route.query.subject_id || ''
  }
  public get getFilters() {
    return this.$store.state.filters
  }
  public get date() {
    return this.$route.query.date || ''
  }
  public get showTip() {
    if (this.name == '17题库' || this.name == '小学OTO') {
      if (this.dataConfig.download_using_questions) {
        return true
      } else {
        if (this.dataConfig.is_downloaded) {
          return false
        } else {
          return true
        }
      }
    } else {
      return false
    }
  }
  public findDetail() {
    if (!loadFromLocal('net_username')) {
      this.$store.commit('SET_LOGINMODAL', true)
      // this.$message.warning('您还没有登录，请先登录')
      return
    }
    if (this.type === 'large') {
      return
    } else {
      // 埋点
      sa.track('ContentRepository_paper_Preview', {
        paperName: this.data.name,
        modules: '试卷'
      })

      window.open(
        '/search/detail' +
          `?_id=${this.data.id}&subject_id=${this.subjectId}&site=${this.site}&site_name=${
            this.name
          }&grade=${this.getFilters.grade}&grade_name=${this.getFilters.grade_name}&paper_type=${
            this.getFilters.paper_type
          }&paper_type_name=${this.getFilters.paper_type_name}&region_code=${
            this.getFilters.region_code
          }&region_name=${this.getFilters.region_name}&year=${
            this.getFilters.year
          }&date=${this.getDate(this.data.date)}&is_downloaded=${this.data.is_downloaded}&costs=${
            this.data.costs
          }`
      )
      // this.$router.push({
      //   path: '/detail',
      //   query: { _id: this.data.id, subject_id: this.subjectId }
      // })
    }
  }
  public imageUrl(data) {
    if (data) {
      return require(`@/assets/svg/${data}`)
    } else {
      return require(`@/assets/svg/file.svg`)
    }
  }
  public getDate(val) {
    if (val) {
      return val
    } else {
      return this.date
    }
  }
  // 是否为精排卷
  public judgeVersion(val) {
    if (val)
      return '<span style="color: #007aff; font-size: 12px;vertical-align: text-top;">【精排】</span>'
    return ''
  }
  // 是否为名校试卷
  public judgeFamousPaper(val: boolean) {
    if (val) {
      return '<span style="color: #007aff; font-size: 12px; margin-right: 0; vertical-align: text-top;">【名校试卷】</span>'
    }
    return ''
  }
}
